export default () => `
  mutation {
    resetCurrentOrder {
      success
      message
    }
  }
`
